import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { PhoneVueTelInputInterface } from '@/types/country.vuetelinput.interface';
import { watch, ref, computed } from 'vue';
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';


export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: null,
    readonly: null,
    profileFormData: null,
    playerCountry: null
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  modelValue: string;
  readonly?: boolean;
  profileFormData: any;
  playerCountry: string;
}





const input = (value) => {
  emit('update:modelValue', value);
};
const fullPhoneNumber = ref('');

const phoneObject = ref({} as { number?: string });

/**
 * Props options for plugin `vue-tel-input`:
 * https://iamstevendao.github.io/vue-tel-input/documentation/props.html
 */
const optionsPhoneInput = computed(() => {
  return {
    mode: 'international',
    inputOptions: {
      id: 'phone',
      name: 'mobile-phone',
      class: 'modal-input',
      placeholder: props.profileFormData.mobile_phone_title,
      readonly: props.readonly,
    },
    dropdownOptions: {
      validCharactersOnly: true,
      showDialCodeInList: false,
      showDialCodeInSelection: false,
      showFlags: true,
    },
    defaultCountry: props.playerCountry.toLowerCase(),
    validCharactersOnly: false,
    preferredCountries: ['au', 'ca', 'nz', 'at', 'ch'],
    // TODO: bug - when you tiping number of ignored country, component will down, PR sended
    // ignoredCountries: ['sk', 'il', 'lt', 'es', 'ua', 'uk', 'fr', 'nl', 'us'],
    autoDefaultCountry: false,
  };
});

watch(
  () => props.modelValue,
  () => {
    if (props.modelValue && props.modelValue !== fullPhoneNumber.value) {
      fullPhoneNumber.value = props.modelValue;
    }
  },
  { immediate: true }
);

watch(fullPhoneNumber, (newValue, oldValue) => {
  if (newValue && newValue !== oldValue) {
    input(newValue);
  }
});

/**
 * Method that formatted phone number on every change
 */
const onChange = (number: string, phone: PhoneVueTelInputInterface) => {
  phoneObject.value = phone;
  if (!props.modelValue && !phone.nationalNumber) {
    if (phone.country?.iso2 === 'CH') {
      fullPhoneNumber.value = `+${phone.country.dialCode} 860`;
    } else {
      fullPhoneNumber.value = `+${phone.country.dialCode}`;
    }
  }
  // SoftSwiss CRUNCH!
  // if country === SWITZERLAND without voice email we must add 860 prefix before nationl number
  if (
    phone.countryCode === 'CH' &&
    !phone.nationalNumber.startsWith('860') &&
    phone.nationalNumber.length === 9 &&
    phone.valid
  ) {
    return input(`+${phone.countryCallingCode} 860 ${phone.nationalNumber}`);
  }
  input(number);
};

return (_ctx: any,_cache: any) => {
  return (__props.playerCountry)
    ? (_openBlock(), _createBlock(_unref(VueTelInput), _mergeProps({ key: 0 }, _unref(optionsPhoneInput), {
        modelValue: fullPhoneNumber.value,
        onOnInput: onChange
      }), null, 16, ["modelValue"]))
    : _createCommentVNode("", true)
}
}

})